/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const MoveDraggerIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M21,9 L3,9" />
      <path d="M21,12 L3,12" />
      <path d="M21,15 L3,15" />
      <polyline points="9 5 12 2 15 5" />
      <polyline points="15 19 12 22 9 19 9 19" />
    </g>
  </svg>
);

export default MoveDraggerIcon;
